export function normalizeTenantId(tenantId?: number | string): number | undefined {
  const parsed = Number(tenantId)
  return Number.isFinite(parsed) ? parsed : undefined
}
